<div class="personal-business-card-setting-container" testId="personal-business-card-setting-page">
  <nz-spin [nzSpinning]="loading" [nzTip]="'common.loading' | i18n" testId="personal-business-card-setting-spin">
    <div class="content-wrapper" testId="personal-business-card-setting-content">
      <servicenumber-business-card
        [serviceNumberId]="serviceNumberId"
        [serviceAvatarUrl]="avatarUrl"
        testId="personal-business-card-setting-card"
      />
    </div>
  </nz-spin>
</div>
